import styled from "styled-components";

export const Wrapper = styled.div`
  line-height: 1.75;

  li {
    position: relative;
    padding-left: 1.25rem;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

export const ProsWrapper = styled.div`
  li {
    &::before {
      content: "+";
      color: ${({ theme }) => theme.colors.accent};
    }
  }
`;

export const ConsWrapper = styled.div`
  li {
    &::before {
      content: "-";
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
